import React from 'react'
import { AppBar, Toolbar, Typography, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import makeStyles from 'shared/makeStyles';
import { useSelector, useDispatch } from 'react-redux'
import { IReduxState } from 'interfaces/IReduxState'
import PlayfulBlobs from 'components/shared/PlayfulBlobs'

const useStyles = makeStyles(theme => ({
  toolbar: {
    minHeight: 64,
  },
  appBarDev: {
    background: '#004526 !important',
    color: '#fff !important',
  },
  cawit: {
    paddingRight: theme.spacing(2),
  },
}))

export default function Navbar() {
  const classes = useStyles()
  const pageTitle: string = useSelector((state: IReduxState) => state.pageTitle)
  const dispatch = useDispatch()

  const stage = process.env.REACT_APP_STAGE
  const isDev = stage === 'dev' || !stage

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        className={
          isDev ? classes.appBarDev : ''
        }
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            aria-label="menu"
            onClick={() => dispatch({ type: 'OPEN_SIDEDRAWER' })}
            color="secondary"
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" style={{ flexGrow: 1 }}>
            {pageTitle || 'Dashboard'}
            {isDev && (
              <span style={{ fontSize: '0.6em', opacity: 0.8, marginLeft: 8 }}>
                (DEV)
              </span>
            )}
          </Typography>
          {pageTitle === 'Login' ? null : (
            <div className={classes.cawit}>
              <PlayfulBlobs size={70} />
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar className={classes.toolbar} />
    </React.Fragment>
  );
}
